import { useEffect, useState, type FormEvent } from "react";
import { Link, useNavigate, useSearchParams } from "react-router";
import { AuthShell, safeNext } from "@/components/auth/AuthShell";
import { errorMessage } from "@/components/auth/issues";
import { Button, TextField } from "@/components/ui/FormControls";
import { useAuth } from "@/store/auth";

/** 로그인 , 이메일 + 비밀번호. 성공하면 ?next(내부 경로만) 로, 없으면 /app 으로 */
export function LoginPage() {
  const [params] = useSearchParams();
  const next = safeNext(params.get("next"));
  const nav = useNavigate();
  const { login, user, ready } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // 이미 로그인돼 있으면(또는 방금 로그인했으면) 바로 목적지로
  useEffect(() => {
    if (ready && user) nav(next, { replace: true });
  }, [ready, user, next, nav]);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(errorMessage(err, "로그인에 실패했습니다. 잠시 뒤 다시 시도해 주세요."));
      setBusy(false);
    }
  }

  return (
    <AuthShell
      title="로그인"
      footer={
        <>
          계정이 없으신가요? <Link to="/signup">가입하기</Link>
        </>
      }
    >
      <form onSubmit={submit} className="auth-form" noValidate>
        <TextField label="이메일" type="email" name="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@company.com" />
        <TextField label="비밀번호" type="password" name="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
        <div className="flex flex-wrap justify-end gap-content text-caption"><Link to="/forgot-password" className="text-accent underline">비밀번호 찾기</Link><Link to="/admin/access" className="text-accent underline">관리자 계정 활성화</Link></div>
        {error && (
          <p role="alert" className="note note-danger text-label">
            {error}
          </p>
        )}
        <div className="mt-label">
          <Button type="submit" variant="primary" fullWidth disabled={busy || !email || !password}>
            {busy ? "확인 중…" : "로그인"}
          </Button>
        </div>
      </form>
    </AuthShell>
  );
}
